<template>
  <BModal
    v-if="canView"
    id="ProductDisplayPageModal"
    :scrollable="false"
    :visible="show"
    size="xxl"
    hide-header
    body-class="p-0"
    @hide="$emit('hide', true)"
  >
    <ProductDisplayPage
      :order-id="orderId"
      :company="company"
      :cart-items="cartItems"
      :selected-product="selectedProduct"
      :store-component-enabled="storeComponentEnabled"
      :user="user"
      :buyer-id="buyerId"
      :on-marketplace="onMarketplace"
      :batch-id="batchId"
      :bulk-discounts="bulkDiscounts"
      :hide-prices="hidePrices"
      :hide-quantities="hideQuantities"
      :disable-add="disableAdd"
      :use-cannabis-spinner="useCannabisSpinner"
      :cart-needs-to-be-chosen="cartNeedsToBeChosen"
      :active-location="activeLocation"
      @added-product="(product) => $emit('addedProduct', product)"
      @contact-button-clicked="$emit('contactButtonClicked')"
      @launch-p-t-o-modal="(val) => $emit('launchPTOModal', val)"
    />
    <template #modal-footer>
      <InfoTooltipBase
        v-if="ownProduct"
        id="thcLimitToolTip"
        placement="top"
        :text="'This is the display your buyers will see. Note: We don\'t list batches here that are not THC compliant or are on-deck.'"
        class="float-left mx-2"
      />
      <BushelBtn variant="dark" ripple-color="dark" flat @click="closeProductDisplayModal"> Close </BushelBtn>
    </template>
  </BModal>
</template>
<script>
import ProductDisplayPage from "@/components/productDisplay/ProductDisplayPage.vue";
import InfoTooltipBase from "@/components/common/InfoTooltipBase.vue";
import BModal from "@/components/base/BModal.vue";

export default {
  components: {
    ProductDisplayPage,
    InfoTooltipBase,
    BModal,
  },
  props: {
    company: { type: Object, default: null },
    cartItems: {
      type: Array,
      default() {
        return [];
      },
    },
    buyerId: { type: Number },
    orderId: { type: Number },
    onMarketplace: { type: Boolean, default: false },
    show: { type: Boolean, required: true },
    user: { type: Object, default: null },
    selectedProduct: { type: Object, required: true },
    canView: { type: Boolean, default: true },
    ownProduct: { type: Boolean, default: false },
    storeComponentEnabled: { type: Boolean, default: true },
    batchId: { type: Number, default: null },
    bulkDiscounts: { type: Array, default: () => [] },
    hidePrices: { type: Boolean, default: false },
    hideQuantities: { type: Boolean, default: false },
    disableAdd: { type: Boolean, default: false },
    useCannabisSpinner: { type: Boolean, default: true },
    cartNeedsToBeChosen: { type: Boolean, default: false },
    activeLocation: { type: Object },
  },
  emits: ["addedProduct", "contactButtonClicked", "launchPTOModal", "hide"],

  mounted() {},
  watch: {
    show(val) {
      console.log("show called");
    },
  },
  methods: {
    closeProductDisplayModal() {
      this.$emit("hide", true);
    },
  },
};
</script>
<style scoped>
.modal-header {
  background: #ffffff !important;
  border: none !important;
  padding: 1rem 1rem 0 !important;
}
</style>
